import { useMemo } from "react";
import { DataSubscription } from "../../../model";
import { Dashboard } from "capitalrx-types";

/**
 * The group table.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GroupTable extends Record<Dashboard.NavigationGroupId, Array<DataSubscription<Dashboard.NavigationItem>>> {
  // empty.
}

/**
 * A group.
 */
export interface Group {

  /**
   * The group ID.
   */
  readonly id: Dashboard.NavigationGroupId;

  /**
   * The group items.
   */
  readonly items: ReadonlyArray<DataSubscription<Dashboard.NavigationItem>>;
}

/**
 * The column data.
 */
export type Columns = ReadonlyArray<ReadonlyArray<Group>>;

/**
 * Groups dashboard subscriptions into groups.
 * @param items The items to group.
 * @param itemsPerRow The number of items per row.
 */
export function useMenuGroups(items: ReadonlyArray<DataSubscription<Dashboard.NavigationItem>>, itemsPerRow: number): Columns {
  return useMemo(() => {
    const result: Array<Array<Group>> = [];
    const groupTable: Partial<GroupTable> = {};
    const groupIds: Array<Dashboard.NavigationGroupId> = [];

    for (const item of items) {
      const { data } = item;
      const { group } = data;

      // I hate this.
      const actualGroup = Dashboard.NavigationGroup[group?.id] ?? Dashboard.NavigationGroup.Unknown;

      if (!groupTable[actualGroup.id]) {
        groupTable[actualGroup.id] = [];
        groupIds.push(actualGroup.id);
      }

      groupTable[group.id]?.push(item);
    }

    const sortedGroupIds = groupIds.sort((a, b) => Dashboard.NavigationGroupMenuOrder[a] - Dashboard.NavigationGroupMenuOrder[b]);
    let counter = 0;
    for (const groupId of sortedGroupIds) {
      const items = groupTable[groupId];
      if (!items) continue;
      const index = counter % itemsPerRow;

      if (!result[index]) {
        result[index] = [{ id: groupId, items }];
      } else {
        result[index].push({ id: groupId, items });
      }

      counter++;
    }

    return result;
  }, [items, itemsPerRow]);
}
